import { generateMockPoints } from './mockGeneration';
export const mockData = generateMockPoints(10);
